import update from "immutability-helper";
import { REPORT, SHOW_TOAST, DISMISS_TOAST } from "./constants";

const initialState = {};

export default (state = initialState, action) => {
  const { type, layout, toastId } = action;
  switch (type) {
    case REPORT:
      return update(state, { $merge: layout });
    case SHOW_TOAST:
      return { ...state, toastId };
    case DISMISS_TOAST:
      const temp_state = {...state};
      delete temp_state['toastId'];
      return temp_state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/layout/reducers.js